const formatNumber = (number) => {
  const formattedNumber = number
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return Number(formattedNumber);
};

export default formatNumber;
